import React, { useEffect, useState } from 'react';
import {S3_URl} from "../config";
import { Box, Tab, Tabs, IconButton, Button, Dialog, DialogTitle, DialogContent,
    DialogActions, TextField,Snackbar, Alert, Card,useMediaQuery , Typography , Grid } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import axiosInstance from '../axiosConfig';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";



export default function Orders() {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box padding="1rem" mt={4}>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                sx={{
                    '& .MuiTabs-flexContainer': {
                        justifyContent: 'flex-start',
                        overflowX: 'auto',
                        paddingLeft: '0.5rem'
                    },
                    backgroundColor: '#f5f5f5'
                }}
            >
                <Tab label="Pre Order Boxes" />
                <Tab label="Customer Orders" />
                <Tab label="Customer Daily Orders" />

            </Tabs>
            {tabValue === 0 && <PreOrderBox />}
            {tabValue === 1 && <CustomerOrders />}
            {tabValue === 2 && <CustomerDailyOrders />}

        </Box>
    );
}

function PreOrderBox() {
    const [preOrderBox, setPreOrderBox] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [newItem, setNewItem] = useState({ title: '', description: '', contents: '', image: '', price: '', category: '' });

    useEffect(() => {
        axiosInstance.get(`/preorderbox/`).then(response => setPreOrderBox(response.data));
    }, []);

    const fetchPreOrderBoxes = (event) => {
        axiosInstance.get(`/preorderbox/`).then(response => setPreOrderBox(response.data));
    }

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
        setPage(0);
    };

    const handleOpenDialog = (item = {}) => {
        setNewItem(item);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => setOpenDialog(false);

    const handleCreateOrUpdate = () => {

        const cleanItem = {
            id: newItem.id,
            title: newItem.title,
            description: newItem.description,
            contents: newItem.contents,
            image: newItem.image,
            price: newItem.price,
            category: newItem.category
        };

        console.log('Sending cleanItem:', cleanItem); // Debugging output

        if (cleanItem.id) {
            axiosInstance.put(`/preorderbox/${cleanItem.id}`, cleanItem).then(fetchPreOrderBoxes);

        } else {
            axiosInstance.post('/preorderbox/', cleanItem).then(fetchPreOrderBoxes);

        }
        setOpenDialog(false);
    };

    const handleDelete = (id) => {
        axiosInstance.delete(`/preorderbox/${id}`)
            .then(fetchPreOrderBoxes);
    };

    const handleDisable = (id) => {
        axiosInstance.delete(`/preorderbox/disable/${id}`)
            .then(fetchPreOrderBoxes);
    };

    const handleEnable = (id) => {
        axiosInstance.delete(`/preorderbox/enable/${id}`)
            .then(fetchPreOrderBoxes);
    };

    const filteredMenus = preOrderBox.filter(menu =>
        menu.title.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <Card sx={{ padding: '1rem', marginTop: '1rem', border: '1px solid #ccc', overflowX: 'auto' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Button variant="contained" onClick={handleOpenDialog} >Add New</Button>
                <TextField label="Search" value={filterText} onChange={handleFilterChange} size="small" />
            </Box>
            {/* Dialog for adding new item */}
            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth>
                <DialogTitle>
                    {newItem.id ? 'Edit PreOrder Box' : 'Create PreOrder Box'}
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseDialog}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField label="Title" fullWidth value={newItem.title} onChange={(e) => setNewItem({ ...newItem, title: e.target.value })} margin="dense" />
                    <TextField label="Description" fullWidth value={newItem.description} onChange={(e) => setNewItem({ ...newItem, description: e.target.value })} margin="dense" />
                    <TextField
                        label="Contents"
                        fullWidth
                        multiline
                        rows={3}
                        value={newItem.contents}
                        onChange={(e) => setNewItem({ ...newItem, contents: e.target.value })}
                        margin="dense"
                    />
                    <TextField label="Image" fullWidth value={newItem.image} onChange={(e) => setNewItem({ ...newItem, image: e.target.value })} margin="dense" />
                    <TextField label="Price" fullWidth type="number" value={newItem.price} onChange={(e) => setNewItem({ ...newItem, price: e.target.value })} margin="dense" />
                    <TextField label="Category" fullWidth value={newItem.category} onChange={(e) => setNewItem({ ...newItem, category: e.target.value })} margin="dense" />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Cancel</Button>
                    <Button onClick={handleCreateOrUpdate} variant="contained" color="primary">Save</Button>
                </DialogActions>
            </Dialog>

            <TableContainer sx={{ minWidth: 600 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>title</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Contents</TableCell>
                            <TableCell>Image</TableCell>
                            <TableCell>Price ($)</TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredMenus.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((menu, index) => (
                            <TableRow key={menu.id}>
                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell>{menu.title}</TableCell>
                                <TableCell>{menu.description}</TableCell>
                                <TableCell>{menu.contents}</TableCell>
                                <TableCell>{menu.image}</TableCell>
                                <TableCell>{menu.category}</TableCell>
                                <TableCell>{menu.price}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleOpenDialog(menu)}><EditIcon /></IconButton>
                                    <IconButton onClick={() => handleDelete(menu.id)}><DeleteIcon /></IconButton>
                                    {menu.active > 0 && <Button onClick={() => handleDisable(menu.id)}>Disable</Button>}
                                    {menu.active < 1 && <Button onClick={() => handleEnable(menu.id)}>Enable</Button>}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredMenus.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            />
        </Card>
    );
}

function CustomerOrders() {
    const [orders, setOrders] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        axiosInstance.get(`/preorderbox/customer/orders`).then(response => setOrders(response.data));
    }, []);

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
        setPage(0);
    };

    const filteredOrders = orders.filter(order =>
        order.customerName.toLowerCase().includes(filterText.toLowerCase())

    );

    return (
        <Card sx={{ padding: '1rem', marginTop: '1rem', border: '1px solid #ccc', overflowX: 'auto' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <TextField label="Search" value={filterText} onChange={handleFilterChange} size="small" />
            </Box>
            <TableContainer sx={{ minWidth: 600 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Customer Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Pick Up/ Delivery</TableCell>
                            <TableCell>Total Price ($)</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Enquiry Date</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>Renewal Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order, index) => (
                            <TableRow key={order.id}>
                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                <TableCell>{order.customerName}</TableCell>
                                <TableCell>{order.email}</TableCell>
                                <TableCell>{order.phone}</TableCell>
                                <TableCell>{order.pickupLocation}</TableCell>
                                <TableCell>{order.totalPrice}</TableCell>
                                <TableCell>{order.title}</TableCell>
                                <TableCell>{order.description}</TableCell>
                                <TableCell>{order.orderDate}</TableCell>
                                <TableCell>{order.deliveryDate}</TableCell>
                                <TableCell>{order.renewalDate}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredOrders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            />
        </Card>
    );
}

function CustomerDailyOrders() {
    const [dailyOrders, setDailyOrders] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Fetch deliveries by selected date
    const fetchDeliveriesByDate = (date) => {
        const formattedDate = date.format('dddd'); // or format('YYYY-MM-DD') if your backend accepts full date
        axiosInstance
            .get(`/preorderbox/customer/deliveries?dayOfWeek=${formattedDate}`)
            .then((response) => {
                setDailyOrders(response.data);
                setPage(0);
            })
            .catch((error) => {
                console.error('Error fetching deliveries:', error);
            });
    };

    // Initial fetch for today on component mount
    useEffect(() => {
        fetchDeliveriesByDate(selectedDate);
    }, []);

    const handleDateChange = (newDate) => {
        if (newDate) {
            setSelectedDate(newDate);
            fetchDeliveriesByDate(newDate);
        }
    };

    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
        setPage(0);
    };

    // Filter based on search text
    const filteredOrders = dailyOrders.filter(order =>
        order.customerName.toLowerCase().includes(filterText.toLowerCase())
    );

    // CSV export helper
    const exportToCSV = (data) => {
        const headers = ['Customer Name', 'Phone', 'Pickup / Delivery', 'Meal Type', 'Day of the Week'];
        const csvRows = [
            headers.join(','),
            ...data.map(order =>
                [
                    `"${order.customerName}"`,
                    `"${order.phone}"`,
                    `"${order.pickupLocation}"`,
                    `"${order.mealType}"`,
                    `"${order.dayOfWeek}"`
                ].join(',')
            )
        ];
        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `CustomerDailyOrders_${selectedDate.format('YYYY-MM-DD')}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    return (
        <Card sx={{ padding: '1rem', marginTop: '1rem', border: '1px solid #ccc' }}>
            <Grid container spacing={2} alignItems="center" mb={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Delivery Date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        label="Search"
                        value={filterText}
                        onChange={handleFilterChange}
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => exportToCSV(filteredOrders)}
                        sx={{ height: '40px' }}
                    >
                        Export to CSV
                    </Button>
                </Grid>
            </Grid>

            {isMobile ? (
                <Box>
                    {filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order, index) => (
                        <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {order.customerName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {order.pickupLocation}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 0.5 }}>
                                Meal Type: {order.mealType}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            ) : (
                <TableContainer sx={{ minWidth: 600 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Customer Name</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Pick Up / Delivery</TableCell>
                                <TableCell>Meal Type</TableCell>
                                <TableCell>Day of the Week</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredOrders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((order, index) => (
                                <TableRow key={index}>
                                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                    <TableCell>{order.customerName}</TableCell>
                                    <TableCell>{order.phone}</TableCell>
                                    <TableCell>{order.pickupLocation}</TableCell>
                                    <TableCell>{order.mealType}</TableCell>
                                    <TableCell>{order.dayOfWeek}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredOrders.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
            />
        </Card>
    );
}
